module.exports = __webpack_public_path__ + "images/copy-button-e680a70d.svg";